import { render } from "./SelectFolderModal.vue?vue&type=template&id=54065470"
import script from "./SelectFolderModal.vue?vue&type=script&lang=js"
export * from "./SelectFolderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__